import React from 'react';
import { MuiThemeProvider, CircularProgress } from "@material-ui/core";
import { theme } from "../../constants/theme";

export const LoadCircular = ({className, size}) => {
    return (
        <MuiThemeProvider theme={theme} ><CircularProgress  size={size} className={className}/></MuiThemeProvider>
    );
};
